// PreviewTester/components/PreviewInfo.js
import React from 'react';
import styles from './PreviewInfo.module.css';

const PreviewInfo = ({ dataType, renderedPreview, parsedData }) => {
  return (
    <div className={styles.previewInfo}>


      {dataType === 'array' && parsedData && (
        <div className={styles.infoBadge}>
          Items: {parsedData.length}
        </div>
      )}
      {dataType === 'object' && parsedData && (
        <div className={styles.infoBadge}>
          Properties: {Object.keys(parsedData).length}
        </div>
      )}
    </div>
  );
};

export default PreviewInfo;